import styled from 'styled-components';

export const StyledContentExpanderContent = styled.div`
   display: flex;
   flex-direction: column;
   margin-top: 5px;
   gap: 5px;
`;
StyledContentExpanderContent.displayName = 'StyledContentExpanderContent';
